import { Option } from "@mittwald/flow-components/dist/components/OrderResourceSelect/styled/Option";
import type { SelectBoxOptionProps } from "@mittwald/flow-components/dist/components/SelectBox";
import React from "react";
import styled from "styled-components";

interface RelocationSelectBoxOptionProps extends SelectBoxOptionProps {}

const StyledOption = styled(Option)`
  text-align: left;

  & > div {
    height: 100%;
    display: flex;
  }

  & > div > span:nth-child(1),
  & > div > span:nth-child(2) {
    align-self: flex-start;
  }

  & > div > span:nth-child(3) {
    align-self: flex-end;
    margin-top: auto;
  }
`;

export const RelocationSelectBoxOption: React.FC<
  RelocationSelectBoxOptionProps
> = (props) => {
  return <StyledOption {...props} />;
};
